(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[102],{

/***/ 73325:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exhibition/why",
      function () {
        return __webpack_require__(66815);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90978);



var TicketModal = function(param) {
    var visible = param.visible, onCancel = param.onCancel;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "jsx-604ce691e976fcb6" + " " + "ticket-modal",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u_, {
                visible: visible,
                centered: true,
                onCancel: onCancel,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "https://img.cbcechina.com/2024-12-10/55680c07f06418fb99396fbc289442e3.png",
                    alt: "",
                    className: "jsx-604ce691e976fcb6"
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "604ce691e976fcb6",
                children: ".semi-modal-content{background-color:transparent;border:none;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none;padding:0;overflow:visible}.semi-modal-body-wrapper{padding:0 20px;margin:0}.semi-modal-close{position:absolute;top:100%;left:50%;-webkit-transform:translateX(-50%);-moz-transform:translateX(-50%);-ms-transform:translateX(-50%);-o-transform:translateX(-50%);transform:translateX(-50%);width:30px;height:30px;background-color:rgb(255,255,255,.4)!important;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;color:#fff!important}.semi-modal-footer{display:none}"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TicketModal);


/***/ }),

/***/ 66815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50313);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_wrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65409);
/* harmony import */ var echarts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15304);
/* harmony import */ var _components_ticket_modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38179);
/* harmony import */ var _utils_useHead__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25838);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81627);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);











var Why = function(param) {
    var menuDetail = param.menuDetail;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_9__/* .useTranslations */ .T_)("exhibition.why");
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShowTicketModal = ref[0], setIsShowTicketModal = ref[1];
    var audiPieOption = {
        title: {
            text: t("section2.chart1.title"),
            subtext: t("section2.chart1.subtext"),
            x: "center",
            y: "175",
            itemGap: 0,
            textStyle: {
                fontFamily: "微软雅黑",
                fontSize: 28,
                fontWeight: "bolder"
            },
            subtextStyle: {
                color: "eee",
                fontSize: 28,
                fontWeight: "bolder"
            }
        },
        tooltip: {
            trigger: "item"
        },
        series: [
            {
                name: "",
                type: "pie",
                radius: [
                    "55%",
                    "80%"
                ],
                animationDuration: 2500,
                startAngle: 80,
                data: [
                    {
                        value: t("section2.chart1.item1num"),
                        name: t("section2.chart1.item1tit"),
                        itemStyle: {
                            color: new echarts__WEBPACK_IMPORTED_MODULE_5__/* .graphic.LinearGradient */ .Q.o(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: "#f3af4a"
                                },
                                {
                                    offset: 1,
                                    color: "#f8f3bd"
                                }
                            ])
                        }
                    },
                    {
                        value: t("section2.chart1.item2num"),
                        name: t("section2.chart1.item2tit"),
                        itemStyle: {
                            color: "#f5c352"
                        }
                    },
                    {
                        value: t("section2.chart1.item3num"),
                        name: t("section2.chart1.item3tit"),
                        itemStyle: {
                            color: "#c9741c"
                        }
                    },
                    {
                        value: t("section2.chart1.item4num"),
                        name: t("section2.chart1.item4tit"),
                        itemStyle: {
                            color: "#e36819"
                        }
                    },
                    {
                        value: t("section2.chart1.item5num"),
                        name: t("section2.chart1.item5tit"),
                        itemStyle: {
                            color: "#f18c1b"
                        }
                    },
                    {
                        value: t("section2.chart1.item6num"),
                        name: t("section2.chart1.item6tit"),
                        itemStyle: {
                            color: new echarts__WEBPACK_IMPORTED_MODULE_5__/* .graphic.LinearGradient */ .Q.o(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: "#f6dc59"
                                },
                                {
                                    offset: 1,
                                    color: "#f8f2bd"
                                }
                            ])
                        }
                    }, 
                ],
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)"
                    }
                },
                labelLine: {
                    // show: false
                    normal: {
                        length: 30
                    }
                },
                label: {
                    show: true,
                    formatter: function formatter(params) {
                        return "{a|" + params.value + "%}" + "\n" + "{b|" + params.name + "}";
                    },
                    offset: [
                        0,
                        0
                    ],
                    overflow: "none",
                    rich: {
                        a: {
                            color: "#fcb814",
                            fontSize: "24px",
                            lineHeight: 30,
                            fontWeight: "bold",
                            align: "left"
                        },
                        b: {
                            color: "#666",
                            fontSize: "14px",
                            fontWeight: "normal",
                            align: "center"
                        }
                    }
                }
            }
        ]
    };
    var audiBarOption = {
        tooltip: {
            trigger: "axis",
            formatter: function formatter(params) {
                // 假设 params.seriesName 是实际数据的系列名
                if (params[0].seriesName == "data") {
                    // 只返回实际数据的值
                    return params[0].name + "<br/>" + params[0].seriesName + ": " + params[0].value + "%";
                }
                // 对于剩余部分的数据，不返回任何内容，这样 tooltip 就不会显示
                return "";
            }
        },
        legend: {
            data: [
                "柱状图1",
                "柱状图2"
            ]
        },
        xAxis: [
            {
                type: "value",
                boundaryGap: [
                    0
                ],
                position: "top",
                data: [
                    "总量"
                ],
                max: 100,
                // scale: 0.8,
                axisLine: {
                    show: false // 是否显示坐标轴线
                },
                axisTick: {
                    // 控制刻度
                    show: false // 不显示刻度
                },
                axisLabel: {
                    // 控制坐标轴标签
                    show: false // 不显示坐标轴标签
                },
                splitLine: {
                    // 控制网格线
                    show: false // 不显示网格线
                }
            }
        ],
        yAxis: [
            {
                type: "category",
                max: 9,
                data: [
                    t("section2.chart2.item1tit"),
                    t("section2.chart2.item2tit"),
                    t("section2.chart2.item3tit"),
                    t("section2.chart2.item4tit"),
                    t("section2.chart2.item5tit"),
                    t("section2.chart2.item6tit"),
                    t("section2.chart2.item7tit"),
                    t("section2.chart2.item8tit"),
                    t("section2.chart2.item9tit"),
                    t("section2.chart2.item10tit"), 
                ],
                axisLabel: {
                    fontSize: "14px",
                    lineHeight: 20,
                    align: "right",
                    margin: 10,
                    color: "#666"
                },
                axisTick: {
                    show: false
                },
                axisLine: {
                    show: false,
                    lineStyle: {
                        color: "#f5f5f5"
                    }
                }
            }
        ],
        series: [
            {
                name: "data",
                type: "bar",
                // barGap: ,
                barGap: "-100%",
                barCategoryGap: "60%",
                animationDuration: 2500,
                // stack: '总量',
                itemStyle: {
                    color: "#fcb814",
                    barBorderRadius: 20
                },
                z: 10,
                data: [
                    t("section2.chart2.item1num"),
                    t("section2.chart2.item2num"),
                    t("section2.chart2.item3num"),
                    t("section2.chart2.item4num"),
                    t("section2.chart2.item5num"),
                    t("section2.chart2.item6num"),
                    t("section2.chart2.item7num"),
                    t("section2.chart2.item8num"),
                    t("section2.chart2.item9num"),
                    t("section2.chart2.item10num"), 
                ]
            },
            {
                name: "剩余部分",
                type: "bar",
                // stack: '总量',
                label: {
                    show: true,
                    position: "right",
                    formatter: function formatter(params) {
                        var data = [
                            t("section2.chart2.item1num"),
                            t("section2.chart2.item2num"),
                            t("section2.chart2.item3num"),
                            t("section2.chart2.item4num"),
                            t("section2.chart2.item5num"),
                            t("section2.chart2.item6num"),
                            t("section2.chart2.item7num"),
                            t("section2.chart2.item8num"),
                            t("section2.chart2.item9num"),
                            t("section2.chart2.item10num"), 
                        ];
                        var percent = data[params.dataIndex] + "%"; // 计算并格式化占比
                        return "{a|" + percent + "}";
                    },
                    rich: {
                        a: {
                            fontSize: 16,
                            color: "#333",
                            fontFamily: "微软雅黑",
                            fontWeight: "500"
                        }
                    }
                },
                itemStyle: {
                    color: "#fee3a1",
                    barBorderRadius: 20
                },
                data: function() {
                    return Array(10).fill(100);
                }()
            }
        ],
        grid: {
            top: "0",
            left: "0",
            right: "65",
            bottom: "0",
            containLabel: true
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var audiPie = echarts__WEBPACK_IMPORTED_MODULE_5__/* .init */ .S1(document.getElementById("audiPie"));
        audiPie.setOption(audiPieOption);
        var audiBar = echarts__WEBPACK_IMPORTED_MODULE_5__/* .init */ .S1(document.getElementById("audiBar"));
        audiBar.setOption(audiBarOption);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_wrapper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                    (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().container)
                ]),
                children: [
                    (0,_utils_useHead__WEBPACK_IMPORTED_MODULE_7__/* .getHead */ .c)(menuDetail),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                            (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().reason),
                            "m-1600"
                        ]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: t("section1.title")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().text),
                                children: t("section1.text")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "https://img.cbcechina.com/2024-11-11/c3688a812349d0b45b672f69b3df2725.png",
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                children: t("section1.item1tit")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                dangerouslySetInnerHTML: {
                                                    __html: t("section1.item1txt")
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "https://img.cbcechina.com/2025-07-18/0409f01b3b008f17f476d3b2f0364e94.jpg",
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                children: t("section1.item2tit")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                dangerouslySetInnerHTML: {
                                                    __html: t("section1.item2txt")
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "https://img.cbcechina.com/2025-07-18/74b2f905327357cbe61abcf845a62bf6.jpg",
                                                alt: ""
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                children: t("section1.item3tit")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                dangerouslySetInnerHTML: {
                                                    __html: t("section1.item3txt")
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                                    (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btns)
                                ]),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: "/exhibition/apply",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                                                    (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().register),
                                                    "btnStyle"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: t("section1.btn1")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                        t: "1723196878237",
                                                        className: "icon",
                                                        viewBox: "0 0 1024 1024",
                                                        version: "1.1",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        "p-id": "2672",
                                                        width: "14",
                                                        height: "14",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            d: "M320 0 192 128l384 384-384 384 128 128 512-512L320 0z",
                                                            "p-id": "2673",
                                                            fill: "#ffffff"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        href: "https://cbce2025.gration.cn/?member/register&code=sites",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            target: "_blank",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                                                    (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().order),
                                                    "btnStyle"
                                                ]),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        children: t("section1.btn2")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                        t: "1723196878237",
                                                        className: "icon",
                                                        viewBox: "0 0 1024 1024",
                                                        version: "1.1",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        "p-id": "2672",
                                                        width: "14",
                                                        height: "14",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                            d: "M320 0 192 128l384 384-384 384 128 128 512-512L320 0z",
                                                            "p-id": "2673",
                                                            fill: "#FCB814"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().banner),
                        src: "https://img.cbcechina.com/2025-07-18/1e22118f3e0859722d25848a55b8bd83.png",
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                            (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().aboutAudi),
                            "m-1600"
                        ]),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: t("section2.title")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().data),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        id: "audiPie",
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().pie)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().bar),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                children: t("section2.chart2.title")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                id: "audiBar",
                                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().audiBar)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().right),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                children: t("section2.chart3.title")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: "/image/lookback-data.png?v=2025",
                                                    alt: ""
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                            (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().meeting),
                            "m-1600"
                        ]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: t("section3.title")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            dangerouslySetInnerHTML: {
                                                __html: t("section3.text")
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btns),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                    href: "/summit/2025",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                                                                (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().more),
                                                                "btnStyle"
                                                            ]),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: t("section3.btn1")
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                                    t: "1723196878237",
                                                                    className: "icon",
                                                                    viewBox: "0 0 1024 1024",
                                                                    version: "1.1",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    "p-id": "2672",
                                                                    width: "14",
                                                                    height: "14",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                        d: "M320 0 192 128l384 384-384 384 128 128 512-512L320 0z",
                                                                        "p-id": "2673",
                                                                        fill: "#231F20"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                                                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().buy),
                                                        "btnStyle"
                                                    ]),
                                                    onClick: function() {
                                                        return setIsShowTicketModal(true);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: t("section3.btn2")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                            t: "1723196878237",
                                                            className: "icon",
                                                            viewBox: "0 0 1024 1024",
                                                            version: "1.1",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            "p-id": "2672",
                                                            width: "14",
                                                            height: "14",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                d: "M320 0 192 128l384 384-384 384 128 128 512-512L320 0z",
                                                                "p-id": "2673"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                            (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().forum),
                            "m-1600"
                        ]),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: t("section4.title")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            dangerouslySetInnerHTML: {
                                                __html: t("section4.text")
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btns),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                    href: "/summit/2025",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                                                                (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().more),
                                                                "btnStyle"
                                                            ]),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    children: t("section4.btn1")
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                                    t: "1723196878237",
                                                                    className: "icon",
                                                                    viewBox: "0 0 1024 1024",
                                                                    version: "1.1",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    "p-id": "2672",
                                                                    width: "14",
                                                                    height: "14",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                        d: "M320 0 192 128l384 384-384 384 128 128 512-512L320 0z",
                                                                        "p-id": "2673",
                                                                        fill: "#231F20"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()([
                                                        (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().buy),
                                                        "btnStyle"
                                                    ]),
                                                    onClick: function() {
                                                        return setIsShowTicketModal(true);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            children: t("section4.btn2")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                            t: "1723196878237",
                                                            className: "icon",
                                                            viewBox: "0 0 1024 1024",
                                                            version: "1.1",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            "p-id": "2672",
                                                            width: "14",
                                                            height: "14",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                d: "M320 0 192 128l384 384-384 384 128 128 512-512L320 0z",
                                                                "p-id": "2673"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ticket_modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        visible: isShowTicketModal,
                        onCancel: function() {
                            return setIsShowTicketModal(false);
                        }
                    })
                ]
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Why);


/***/ }),

/***/ 50313:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"m-1600":"why_m-1600__UkTYH","container":"why_container__sKDPF","reason":"why_reason__8ywMl","text":"why_text__DMAeB","btns":"why_btns__8D6wE","register":"why_register__bDmTJ","order":"why_order__FdtxI","aboutAudi":"why_aboutAudi__oE3K_","data":"why_data__U05wG","right":"why_right__KN9wg","pie":"why_pie__BQoXj","bar":"why_bar__NIlEF","audiBar":"why_audiBar__RBGwv","meeting":"why_meeting__T_MUh","more":"why_more__eBJq8","buy":"why_buy__Iw5Rz","forum":"why_forum__TUpjp","banner":"why_banner__CRTDZ"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [304,342,774,888,179], function() { return __webpack_exec__(73325); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);